import { GeneralAttributeRateKeyBase } from './base/general-attribute-rate-key-base';

export class GeneralAttributeRateKey extends GeneralAttributeRateKeyBase { }